import RouteTemplate from "ember-route-template";
import { on } from "@ember/modifier";
import { concat } from "@ember/helper";
import not from "truth-helpers/helpers/not";

export default RouteTemplate(
  <template>
    <section class="proxyviews-directory-page">
      <div class="pd-hero">
        <span class="pd-hero__eyebrow">Performance Lab</span>
        <h1 class="pd-hero__title">Provider <span>Comparison</span></h1>
        <p class="pd-hero__subtitle">
          Side-by-side benchmark summary across the selected providers.
        </p>
        <button type="button" class="btn btn-default pd-hero__back" {{on "click" @controller.goBack}}>
          &larr; Back to Benchmarks
        </button>
      </div>

      {{#if @model.error}}
        <div class="alert alert-error">
          Couldn't load the comparison. Please try again.
        </div>
      {{else if (not @model.providers)}}
        <div class="pd-empty-state">
          <div class="pd-empty__icon">&#128202;</div>
          <h3 class="pd-empty__title">No providers selected</h3>
          <p class="pd-empty__description">Select providers on the benchmarks page to compare them.</p>
          <button type="button" class="btn btn-primary pd-empty__action" {{on "click" @controller.goBack}}>
            Go to Benchmarks
          </button>
        </div>
      {{else if (not @controller.hasData)}}
        <div class="pd-empty-state">
          <div class="pd-empty__icon">&#128202;</div>
          <h3 class="pd-empty__title">No benchmark data</h3>
          <p class="pd-empty__description">None of the selected providers have benchmark runs yet.</p>
        </div>
      {{else}}
        <div class="pd-admin-table-container">
          <table class="pd-admin-table proxyviews-benchmark-table">
            <thead>
              <tr>
                <th scope="col">Provider</th>
                <th scope="col">Avg Response</th>
                <th scope="col">Min</th>
                <th scope="col">Max</th>
                <th scope="col">Avg Success</th>
                <th scope="col">Avg Block</th>
                <th scope="col">Total Runs</th>
                <th scope="col">Best Grade</th>
                <th scope="col">Reliability</th>
              </tr>
            </thead>
            <tbody>
              {{#each @model.summary as |row|}}
                <tr>
                  <td class="is-provider"><strong>{{row.provider_name}}</strong></td>
                  <td class="is-numeric">{{if row.avg_response_time_ms (concat (row.avg_response_time_ms.toFixed 0) 'ms') '—'}}</td>
                  <td class="is-numeric">{{if row.min_response_time_ms (concat (row.min_response_time_ms.toFixed 0) 'ms') '—'}}</td>
                  <td class="is-numeric">{{if row.max_response_time_ms (concat (row.max_response_time_ms.toFixed 0) 'ms') '—'}}</td>
                  <td class="is-numeric">{{if row.avg_success_rate (concat (row.avg_success_rate.toFixed 1) '%') '—'}}</td>
                  <td class="is-numeric">{{if row.avg_block_rate (concat (row.avg_block_rate.toFixed 1) '%') '—'}}</td>
                  <td class="is-numeric">{{row.total_runs}}</td>
                  <td class="is-numeric">
                    {{#if row.best_grade}}
                      <span class="proxyviews-grade-badge {{@controller.gradeClassFor row.best_grade}}">{{row.best_grade}}</span>
                    {{else}}—{{/if}}
                  </td>
                  <td class="is-numeric">
                    {{#if row.reliability_grade}}
                      <span class="proxyviews-grade-badge {{@controller.gradeClassFor row.reliability_grade}}">{{row.reliability_grade}}</span>
                    {{else}}—{{/if}}
                  </td>
                </tr>
              {{/each}}
            </tbody>
          </table>
        </div>
      {{/if}}
    </section>
  </template>
);
